// src/teams/team/types.ts
var TeamsTeamAriResourceOwner = "teams", TeamsTeamAriResourceType = "team";

export {
  TeamsTeamAriResourceOwner,
  TeamsTeamAriResourceType
};
